module.exports = __webpack_public_path__ + "static/flags/TS-10d12fd1cb542f7de1092fcbfbb17d21.gif";